import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import './searchbar.css';
import LocationLogo from '../logo/Location.svg';
import SearchLogo from '../logo/Search.svg';


const Searchbar = ({ initialKeyword, shouldPushHistory = false }) => {
  const [input, setInput] = useState(initialKeyword);
  const history = useHistory();
  
  const onSubmit = (e) => {
    e.preventDefault();
    const newLocation = {
      pathname: '/info',
      search: `?keyword=${input}`
    };
    if (shouldPushHistory) history.push(newLocation);
    else history.replace(newLocation);
    history.go(0);
  }

  return (
    <form className="d-flex justify-content-space-around form-search" data-testid="form" onSubmit={onSubmit}>
      <div className="searchbar d-flex">
        <img src={LocationLogo} className="location-logo" alt="location-logo"></img>
        <input
          data-testid="searchbar"
          name="search-poi"
          className="form-search-bar"
          value={input}
          placeholder={"Cari destinasimu di sini ..."}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
      <button type="submit" className="button-search button" data-testid="search-button">
        <img src={SearchLogo} className="search-logo" alt="search-logo" />
        <span className="button">Cari</span>
      </button>
    </form>
  );
}

export default Searchbar